import { default as invoiceMinus } from "../../../icons/invoiceMinus.svg";

import React, {useEffect} from "react";
import "../InvoicePage.scss";
import { Returntext } from "../../Landings/common/returnText";
import { useContent, useLanguages } from "../../../hooks/content";

function InvoicePriceComponent({ props }) {
    const { lang } = useLanguages();
    const { contentManagementData } = useContent();
    const [data, setData] = React.useState(null);
    const formatValue = (val) => Number(val).toFixed(2);

    useEffect(() => {
        setData({
            usaDelivery: {
                key: Returntext(contentManagementData, 'poi_content_costs_usa_delivery', lang),
                value: formatValue(props.usa_pickup)
            },
            flight: {
                key: Returntext(contentManagementData, 'poi_content_costs_air_transfer', lang),
                value: formatValue(props.usa_air)
            },
            additionalFee: {
                key: Returntext(contentManagementData, 'poi_content_costs_additional_fee', lang),
                value: formatValue(props.additional)
            },
            regionDeliveryGeorgia: {
                key: Returntext(contentManagementData, 'poi_content_costs_georgian_region_delivery', lang),
                value: props.delivery.type === 'Region' ? formatValue(props.delivery.price) : '0.00'
            },
            tbilisiDelivery: {
                key: Returntext(contentManagementData, 'poi_content_costs_tbilisi_delivery', lang),
                value: props.delivery.type === 'Tbilisi_Delivery' ? formatValue(props.delivery.price) : '0.00'
            },
            total: {
                key: Returntext(contentManagementData, 'poi_content_costs_total', lang),
                value: formatValue(props.total)
            },
        })
    }, [lang]);

    return (
        <div className="invoice-sheet">
            <div className="invoice-title">
                <span>{ Returntext(contentManagementData, 'poi_sheet_title_costs', lang) }</span>
                <img src={invoiceMinus} alt="minus"/>
            </div>
            <div className="invoice-sheet-container">
                {   data?.usaDelivery.value !== '0.00' && (
                        <div className="invoice-item">
                            <div>{ data?.usaDelivery.key }</div>
                            <span>${ data?.usaDelivery.value }</span>
                        </div>
                    )
                }

                {
                    data?.flight.value !== '0.00' && (
                        <div className="invoice-item">
                            <div>{ data?.flight.key }</div>
                            <span>${ data?.flight.value }</span>
                        </div>
                    )
                }

                {
                    data?.additionalFee.value !== '0.00' && (
                        <div className="invoice-item">
                            <div>{ data?.additionalFee.key }</div>
                            <span>${ data?.additionalFee.value }</span>
                        </div>
                    )
                }

                {
                    data?.regionDeliveryGeorgia.value !== '0.00' && (
                        <div className="invoice-item">
                            <div>{ data?.regionDeliveryGeorgia.key }</div>
                            <span>${ data?.regionDeliveryGeorgia.value }</span>
                        </div>
                    )
                }

                {
                    data?.tbilisiDelivery.value !== '0.00' && (
                        <div className="invoice-item">
                            <div>{ data?.tbilisiDelivery.key }</div>
                            <span>${ data?.tbilisiDelivery.value }</span>
                        </div>
                    )
                }

                <div className="invoice-item total-price">
                    <div>{ data?.total.key }</div>
                    <div>${ data?.total.value }</div>
                </div>
            </div>
        </div>
    )
}

export default InvoicePriceComponent;